import moment from "moment";
import {Network} from "./network";
import "react-native-get-random-values";
import {
  globalConfigurableData,
  globalConst,
  partnerMap,
} from "./globalConstant";

import {Linking, PermissionsAndroid, Platform, Share} from "react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import "react-native-get-random-values";
import {firebase} from "@react-native-firebase/dynamic-links";
import dynamicLinks from "@react-native-firebase/dynamic-links";
import Toast from "react-native-toast-message";
import {
  hideLoader,
  showLoader,
} from "../commonComponents/Loader/loader.actions";
import {INDIA, REST_OF_WORLD} from "./constants";
import {globalImport} from "../common/globalImports";
import Width from "../assets/Width";
import {getCurrentRoute} from "../navigation/rootNavigation";
import {store} from "../store/store";
import {bangaladeshi_rupee, pakistani_rupee, usdt_currency} from "./images";
import {convert} from "../locale/translateText";
import {GlobalScreens} from "./globalConstant";
import {TEST_API_D24} from "./apiUrl";
import {setShowLoginModal} from '../screens/Login/redux/login.action';

export const RegEx = {
  alphabeicalChar: /^[A-Za-z_ ]+$/i,
  email:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  mobile: /^[6-9][0-9]{9}$/,
  ifsc: /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/,
  pan: /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?/,
  accountNum: /^[0-9]+$/,
  tradeNum: /^[0-9]\d*(\.\d+)?$/,
};

export const countryRegion = {region: ""};

export const setCountry = item => {
  countryRegion.region = item;
};

export const partnerData = {partnerId: 1};

export const setPartnerData = item => {
  partnerData.partnerId = item;
};

export const isSkipUpdate = {isSkip: ""};

export const setSkip = item => {
  isSkipUpdate.isSkip = item;
};

export const CountryRegEx = {
  IN: /^[6-9][0-9]{9}$/,
  ID: /^(\d{3,4}-?){2}\d{3,4}$/,
  BR: /^\s*(\d{2}|\d{0})[-. ]?(\d{5}|\d{4})[-. ]?(\d{4})[-. ]?\s*$/,
};

export async function buildLink(eventName, eventId, userId, hideLoader) {
  const link = await dynamicLinks().buildShortLink(
    {
      domainUriPrefix: "https://pages.tradexapp.co",
      android: {
        packageName: "com.theox",
        fallbackUrl: `https://web.tradexapp.co`,
      },
      ios: {
        bundleId: "com.theox",
        fallbackUrl:
          "https://apps.apple.com/us/app/tradex-markets/id1608795674",
        appStoreId: "1608795674",
        iPadBundleId: "com.theox",
        iPadFallbackUrl:
          "https://apps.apple.com/us/app/tradex-markets/id1608795674",
      },
      link: `https://web.tradexapp.co/deeplink/?probeid=${eventId}&eventtype=Bet&referredBy=${userId}`,
    },
    firebase.dynamicLinks.ShortLinkType.UNGUESSABLE,
  );
  const msg =
    "Hey, What do you think will happen? \n" +
    eventName +
    " Click on this link " +
    link +
    " to participate";
  Share.share({
    message: msg,
  }).then(() => {
    hideLoader();
  });
  return link;
}

export async function buildLinkContest(
  contestId,
  contestName,
  sharaebleLink,
  prizePool,
) {
  // const link = await dynamicLinks().buildShortLink(
  //   {
  //     domainUriPrefix: "https://pages.tradexapp.co",
  //     android: {
  //       packageName: "com.theox",
  //       fallbackUrl: `https://web.tradexapp.co`,
  //     },
  //     ios: {
  //       bundleId: "com.theox",
  //       fallbackUrl:
  //         "https://apps.apple.com/us/app/tradex-markets/id1608795674",
  //       appStoreId: "1608795674",
  //       iPadBundleId: "com.theox",
  //       iPadFallbackUrl:
  //         "https://apps.apple.com/us/app/tradex-markets/id1608795674",
  //     },
  //     link: `https://web.tradexapp.co/Fantasy/${contestId}`,
  //   },
  //   firebase.dynamicLinks.ShortLinkType.UNGUESSABLE
  // );

  const msg =
    "Inviting you to join TradeX group contest - " +
    contestName +
    " and win rewards upto 10k. Click below link to join " +
    sharaebleLink;

  Share.share({
    message: msg,
  }).then(() => {
    store.dispatch(hideLoader());
  });
  return sharaebleLink;
}

export async function buildLinkContestEvent(
  contestId,
  eventId,
  eventNaame,
  shareLink,
) {
  // const link = await dynamicLinks().buildShortLink(
  //   {
  //     domainUriPrefix: "https://pages.tradexapp.co",
  //     android: {
  //       packageName: "com.theox",
  //       fallbackUrl: `https://web.tradexapp.co`,
  //     },
  //     ios: {
  //       bundleId: "com.theox",
  //       fallbackUrl:
  //         "https://apps.apple.com/us/app/tradex-markets/id1608795674",
  //       appStoreId: "1608795674",
  //       iPadBundleId: "com.theox",
  //       iPadFallbackUrl:
  //         "https://apps.apple.com/us/app/tradex-markets/id1608795674",
  //     },
  //     link: `https://web.tradexapp.co/Fantasy/${contestId}/${eventId}/false`,
  //   },
  //   firebase.dynamicLinks.ShortLinkType.UNGUESSABLE
  // );
  const msg =
    "Hey, What do you think will happen? \n" +
    eventNaame +
    " Click on this link " +
    shareLink +
    " to participate";

  Share.share({
    message: msg,
  }).then(() => {
    hideLoader();
  });
  return link;
}

export const conversionMethod = conversionData => {
  if (conversionData?.success) {
    return convert("(1 ≈ credits*)", {
      from: conversionData?.result?.from,
      value: conversionData?.result?.value?.toFixed(2),
    });
  } else {
    return "(₹ 1 = 1 credit)";
  }
};

const chars =
  "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

export function isMobile(param) {
  var check = false;
  if (partnerMap?.isKostar) return true;
  if (Platform.OS === "web") {
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4),
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
  } else {
    return true;
  }

  return check;
}

export function isMobileCheck() {
  var check = false;

  if (Platform.OS === "web") {
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4),
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
  } else {
    return true;
  }

  return check;
}

export const currencyConverter = value => {
  if (value === undefined || value === null) return '0';
  
  let val = parseFloat(value);
  if (isNaN(val)) return '0';
  
  if (val >= 10000000) {
    val = parseFloat((val / 10000000).toFixed(2)) + " Cr";
  } else if (val >= 100000) {
    val = parseFloat((val / 100000).toFixed(2)) + " Lac";
  } else if (val >= 1000) {
    val = parseFloat((val / 1000).toFixed(2)) + " k";
  } else {
    val = parseFloat(val.toFixed(2));
  }
  return val;
};

export function convertToInternationalCurrencySystem(labelValue) {
  // Nine Zeroes for Billions
  if (labelValue) {
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? (Math.abs(Number(labelValue)) / 1.0e9).toFixed(2) + " B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? (Math.abs(Number(labelValue)) / 1.0e6).toFixed(2) + " M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? (Math.abs(Number(labelValue)) / 1.0e3).toFixed(2) + " K"
      : Math.abs(Number(labelValue));
  } else {
    return labelValue;
  }
}

export const timeLagFromCurrentTime = (date, removeText) => {
  var seconds = moment().diff(date, "seconds");
  if (seconds < 0) {
    return timeSinceCurrentTime(Math.abs(seconds), date, removeText);
  }
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);

  if (d > 8) {
    return d + " days ago";
  } else if (d / 7 >= 1) {
    return true ? "1 week ago" : "Last week";
  } else if (d >= 1 && d < 2) {
    return "1 day ago";
  } else if (d >= 2) {
    return d + " days ago";
  } else if (h >= 2) {
    return `${h} hours ago`;
  } else if (h >= 1) {
    return "1 hour ago";
  } else if (m >= 2) {
    return `${m} minutes ago`;
  } else if (m >= 1) {
    return "A minute ago";
  } else if (s >= 3) {
    return `${s} seconds ago`;
  } else {
    return "Just now";
  }
};

export const timeSinceCurrentTime = (seconds, date, removeText) => {
  var d = Math.floor(seconds / (3600 * 24));
  var h = Math.floor((seconds % (3600 * 24)) / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor(seconds % 60);
  let addS = true;
  let dt, dtf;
  if (d >= 1) {
    if (d == 1) {
      addS = false;
    }
    dt = removeText ? `${d} day` : `Ends in ${d} day`;
  } else if (h < 24 && h >= 1) {
    if (h == 1) {
      addS = false;
    }
    dt = removeText ? `${h} hour` : `Ends in ${h} hour`;
  } else if (h < 1 && m >= 1) {
    if (m == 1) {
      addS = false;
    }
    dt = removeText ? `${m} minute` : `Ends in ${m} minute`;
  } else if (m < 1 && s >= 5) {
    dt = removeText ? `${s} second` : `Ends in ${s} second`;
  } else if (s < 5 && s > 0) {
    addS = false;
    dt = "Almost now";
  } else if (s <= 0) {
    addS = false;
    dt = `Ended ${date}`;
  }

  if (addS) {
    dtf = dt + "s";
  } else {
    dtf = dt;
  }
  return dtf;
};

export const formatPL = val => {
  const suffix = "%";
  if (isNaN(val)) {
    return `${0.0}${suffix}`;
  }
  if (val > 0) return `+${val}${suffix}`;
  return `${val}${suffix}`;
};

export const formatCurrency = (val, currency = "") => {
  return `${currency} ${val}`;
};

export const getQueryStringParameters = url => {
  try {
    if (url && url.split("?").length > 0) {
      const query = url.split("?")[1];
      return (/^[?#]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          const [key, value] = param.split("=");
          params[key] = value
            ? decodeURIComponent(value.replace(/\+/g, " "))
            : "";
          return params;
        }, {});
    }
    return {};
  } catch (err) {
    //
  }
};

export const requestPermision = async PERMISSION_NAME => {
  console.log(PERMISSION_NAME);
  try {
    let isPermissionGranted = await PermissionsAndroid.check(
      PermissionsAndroid.PERMISSIONS[PERMISSION_NAME],
    );

    if (!isPermissionGranted) {
      let granted = await PermissionsAndroid.request(
        PermissionsAndroid.PERMISSIONS[PERMISSION_NAME],
      );
      if (granted === PermissionsAndroid.RESULTS.GRANTED) {
        return true;
      } else {
        return false;
        alert("permission not granted");
        // alert('permission denied - enable permission from settings');
      }
    } else {
      return true;
    }
  } catch (err) {}
};

export function atob(input = "") {
  let str = input.replace(/=+$/, "");
  let output = "";

  if (str.length % 4 == 1) {
    throw new Error(
      "'atob' failed: The string to be decoded is not correctly encoded.",
    );
  }
  for (
    let bc = 0, bs = 0, buffer, i = 0;
    (buffer = str.charAt(i++));
    ~buffer && ((bs = bc % 4 ? bs * 64 + buffer : buffer), bc++ % 4)
      ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
      : 0
  ) {
    buffer = chars.indexOf(buffer);
  }

  return output;
}
export function btoa(input = "") {
  let str = input;
  let output = "";

  for (
    let block = 0, charCode, i = 0, map = chars;
    str.charAt(i | 0) || ((map = "="), i % 1);
    output += map.charAt(63 & (block >> (8 - (i % 1) * 8)))
  ) {
    charCode = str.charCodeAt((i += 3 / 4));

    if (charCode > 0xff) {
      throw new Error(
        "'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.",
      );
    }

    block = (block << 8) | charCode;
  }

  return output;
}

export function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

export const sendLoggedInMoengageEvent = async page => {
  try {
    var last_logout = await AsyncStorage.getItem("logoutdate");
    var days = 0;
    var hours = 0;
    var minutes = 0;
    var seconds = 0;
    if (last_logout) {
      var lastlogoutDate = new Date(last_logout);
      var currentdate = new Date();
      var delta = Math.abs(lastlogoutDate - currentdate) / 1000;

      days = Math.floor(delta / 86400);
      delta -= days * 86400;

      hours = Math.floor(delta / 3600) % 24;

      delta -= hours * 3600;

      minutes = Math.floor(delta / 60) % 60;
      delta -= minutes * 60;

      seconds = delta % 60;
    }

    var last_login = await AsyncStorage.getItem("last_login");
    var lastloginDate = new Date(last_login);
    var isSameDay = false;
    if (last_login) {
      isSameDay =
        lastloginDate.getDate() === currentdate.getDate() &&
        lastloginDate.getMonth() === currentdate.getMonth() &&
        lastloginDate.getFullYear() === currentdate.getFullYear();
    }

    trackMoengageEvent("Logged In", {
      Time_after_previous_logout:
        hours + ":" + minutes + ":" + seconds + ":" + days,
      First_Session_Today: isSameDay ? false : true,
    });
  } catch (err) {
    //
  }
};


export const openURL = link => {
  if (link && link !== undefined && link !== "undefined") {
    Linking.canOpenURL(link).then(supported => {
      if (supported) {
        Linking.openURL(link);
      } else {
        alert('Issues in Opening the URL, try after sometime');
        console.log("Don't know how to open URI: " + link);
      }
    });
  }
};

export const trackAppsflyerEvent = (event = "", properties = {}) => {
  // properties = {
  //   ...properties,
  //   device: "mobileRN",
  // };
  // if (event === "recharge_amount") {
  //   if (globalImport.isWeb) {
  //     globalImport.singularSdk.revenue(
  //       event,
  //       properties?.af_currency,
  //       +properties?.af_revenue,
  //       properties,
  //     );
  //   } else {
  //     globalImport.singularSdk.customRevenue(
  //       event,
  //       properties?.af_currency,
  //       +properties?.af_revenue,
  //       properties,
  //     );
  //   }
  // } else {
  //   if (!globalImport.isWeb) {
  //     globalImport.singularSdk.eventWithArgs(event, properties);
  //   } else {
  //     globalImport.singularSdk.event(event, properties);
  //   }
  // }
};

export const generateInviteLink = (
  couponCode,
  region,
  displayName,
  uid,
  referText,
) => {
  var onInviteLinkSuccess = async function (link, referText) {
    var msg = "";
    msg = referText + link;
    // if (region !== INDIA) {
    //   msg =
    //     'Join me on ' +
    //     globalConst?.appName +
    //     ' and earn by making predictions on Cyrpto, sports and many more. Download app ' +
    //     link;
    // } else {
    //   msg =
    //     'Here’s your free 10 to trade on your opinions On ' +
    //     globalConst?.appName +
    //     ' Click ' +
    //     link +
    //     ' to download ' +
    //     globalConst?.appName +
    //     ' app & use My code ' +
    //     couponCode +
    //     ' to Register';
    // }

    const result = await Share.share({
      message: msg,
    });
  };

  if (!globalImport.isWeb) {
    onInviteLinkSuccess(`${TEST_API_D24}?referCode=` + couponCode, referText);
  } else {
    onInviteLinkSuccess(`${TEST_API_D24}?referCode=` + couponCode, referText);
  }
};

export async function buildLinkHashTag(hashtag, subcat, hideLoader) {
  const link = await dynamicLinks().buildShortLink(
    {
      domainUriPrefix: 'https://pages.tradexapp.co',
      android: {
        packageName: 'com.theox',
        fallbackUrl: `https://web.tradexapp.co`,
      },
      ios: {
        bundleId: 'com.theox',
        fallbackUrl:
          'https://apps.apple.com/us/app/tradex-markets/id1608795674',
        appStoreId: '1608795674',
        iPadBundleId: 'com.theox',
        iPadFallbackUrl:
          'https://apps.apple.com/us/app/tradex-markets/id1608795674',
      },
      link: `https://web.tradexapp.co/deeplink/?hashtag=${hashtag}&subcat=${subcat}`,
    },
    firebase.dynamicLinks.ShortLinkType.UNGUESSABLE,
  );
  const msg =
    'Hey, checkout this trending hashtag \n' +
    hashtag +
    ' Click on this link ' +
    link +
    ' to participate';
  Share.share({
    message: msg,
  }).then(() => {
    hideLoader();
  });
  return link;
}

export const requestGalleryPermission = async () => {
  try {
    const granted = await PermissionsAndroid.check(
      PermissionsAndroid.PERMISSIONS.READ_EXTERNAL_STORAGE,
    );
    if (granted === PermissionsAndroid.RESULTS.GRANTED) {
      return true;
    }
    const granted1 = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.READ_EXTERNAL_STORAGE,
    );
    if (granted1 === PermissionsAndroid.RESULTS.GRANTED) {
      return true;
    }
    if (granted1 === PermissionsAndroid.RESULTS.NEVER_ASK_AGAIN) {
      Toast.show({
        type: "info",
        text1:
          "Please enable gallery permission for this app from the app settings",
        visibilityTime: 2000,
        position: "bottom",
      });
    }
  } catch (err) {
    console.log(err);
  }
};

export const trackMoengageEvent = (event = "", properties = {}) => {
  // properties = {
  //   ...properties,
  //   device: "app",
  // };
  // if (!globalImport.isWeb) {
  //   globalImport.CleverTap.recordEvent(event, properties);
  // } else {
  //   if (window?.clevertap) {
  //     window?.clevertap?.event?.push(event, properties);
  //   }
  // }
};

export const checkColums = () => {
  if (Width.width <= 550) {
    return 1;
  } else if (Width.width > 550 && Width.width < 900) {
    return 2;
  } else {
    return 3;
  }
};

export const isContestRoute = () => {
  const currRoute = getCurrentRoute() || window?.location?.pathname;
  if (currRoute && currRoute !== "") {
    if (
      currRoute.includes("ContestEvents") ||
      currRoute.includes("ContestPortfolio") ||
      currRoute.includes("contestDetail") ||
      currRoute.includes("Fantasy")
    ) {
      return true;
    }
  }
  return false;
};

const getCurrency = (region, signup_country) => {
  let currentCurrency = "INR";
  if (signup_country === "BD" || signup_country === "PK") {
    currentCurrency = signup_country;
  } else if (region === REST_OF_WORLD) {
    currentCurrency = "USDT";
  }
  return currentCurrency;
};

export const getDepositAmountPlaceholder = (region, signup_country) => {
  const currentCurrency = getCurrency(region, signup_country);
  const a = {
    BD: "Enter Amount in TAKA",
    PK: "Enter Amount in PKR",
    USDT: "Enter amount in USDT",
    INR: "Enter amount",
  };
  return a[currentCurrency];
};

export const getCurrencyIcon = (region, signup_country) => {
  const currentCurrency = getCurrency(region, signup_country);
  const a = {
    BD: bangaladeshi_rupee(),
    PK: pakistani_rupee(),
    USDT: usdt_currency(),
  };
  return a[currentCurrency];
};

export const delayString = (watchamount, currency, conversionData) => {
  if (watchamount) {
    var min = (watchamount * conversionData?.result?.value).toFixed(2);
    var max = (watchamount / conversionData?.result?.value).toFixed(2);
    var msg = currency
      ? " ≈ " + max + " " + currency
      : " ≈ " + min + " credits*";
    return msg;
  } else {
    return "";
  }
};

export const getLoginRoute = () => {
  return false ? "LoginOptions" : "Login";
};

export const routeMap = {
  loginCoupon:
     '{"stale":false,"type":"stack","key":"stack-7EFhjkYEdUkH33qfhYCtn","index":1,"routeNames":["Home","Login","HashTag","Event","ClubStack","RewardsStack","Fantasy","LoginOptions","Direct24","PartnerError"],"routes":[{"key":"Home-AOolXQfuyS1zSwkFFuTGP","name":"Home","state":{"stale":false,"type":"tab","key":"tab-hMB56QmBcu5MF0Gnlkp8D","index":0,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-8-zOwviZbUO4Wqr4CjSnJ"}],"routes":[{"name":"Markets","key":"Markets-8-zOwviZbUO4Wqr4CjSnJ"},{"name":"Contest","key":"Contest-Eoq5CZfmvDzw28eqXLmBD"},{"name":"Portfolio","key":"Portfolio-2huXm7is2XLHwebagiCMr"},{"name":"Wallet","key":"Wallet-FHOvJtjWzKa5MkuRX8R5l"}]}},{"key":"Login-FJCNS9Uuy2M0MpRLc2SMR","name":"Login","params":{"coupon":"CITYMALL"}}]}',
  otpless:
    '{"stale":false,"type":"stack","key":"stack-rLubcidLZJCULWPbqD0KX","index":2,"routeNames":["Home","Login","HashTag","Event","ClubStack","Fantasy","LoginOptions"],"routes":[{"key":"Home-J4nSyrdtwKnOABMO-yPE7","name":"Home","state":{"stale":false,"type":"tab","key":"tab-TKyX2zviObC4yXo2yy756","index":0,"routeNames":["Markets","Portfolio","Contest","Wallet","Live"],"history":[{"type":"route","key":"Markets-CA4Brq_XMX04NypqTR7Vz"}],"routes":[{"name":"Markets","key":"Markets-CA4Brq_XMX04NypqTR7Vz"},{"name":"Portfolio","key":"Portfolio-yYNpTxxCb_m5ChXlUtbsn"},{"name":"Contest","key":"Contest-MEoYd5pU1GA0ORXCRd4OT"},{"name":"Wallet","key":"Wallet-ePDA2WKrlLLvlBo7fBfcH"},{"name":"Live","key":"Live-aDESoY58i8yT6CXzJV6QU"}]}},{"key":"LoginOptions-uK4iKRzTSACA4lr-A8Kra","name":"LoginOptions"},{"key":"Login-KAda72Dv1muCCm9ETlXug","name":"Login","params":{"sId":true}}]}',
  eventId:
    '{"stale":false,"type":"stack","key":"stack-gfz0XFYMgUuumaeKs9br_","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection"],"routes":[{"key":"Home-NG8CVYm2TFYzXoI7kjL4I","name":"Home","state":{"stale":false,"type":"tab","key":"tab-dLcJLadsS6w_oOWPfLLy7","index":0,"routeNames":["Markets","Portfolio","Contest","Wallet","Live"],"history":[{"type":"route","key":"Markets-5pgQ0UFWGUkIymAL3jy_R"}],"routes":[{"name":"Markets","key":"Markets-5pgQ0UFWGUkIymAL3jy_R"},{"name":"Portfolio","key":"Portfolio-uQxHubAeX0aNeN9kFjH-v"},{"name":"Contest","key":"Contest-C2LstN0UFEM5DeGCaNb3K"},{"name":"Wallet","key":"Wallet-B3bt1Plv2zDRjQikXK4xd"},{"name":"Live","key":"Live-sPvZa3CNs9BgHnyw2miZg"}]}},{"key":"Event-I0S7o7tZLgNombaWMj16-","name":"Event","params":{"eventId":138626,"isMulti":false}}]}',
  login:
    '{"stale":false,"type":"stack","key":"stack-wHkUQR3fWT693RcXUPYec","index":1,"routeNames":["Home","Login","HashTag","Event","ClubStack","Fantasy","LoginOptions","Direct24","PartnerError"],"routes":[{"name":"Home","key":"Home-IayJJhuz3Fgor9s9vmR5P","state":{"stale":false,"type":"tab","key":"tab-JC5ySQaKSlhivu2WbWA4V","index":0,"routeNames":["Markets","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-sW3VVyLELWtwhOpOgQjuu"}],"routes":[{"name":"Markets","key":"Markets-sW3VVyLELWtwhOpOgQjuu"},{"name":"Portfolio","key":"Portfolio-ZpT62l4fdA0W3zVac_asR"},{"name":"Wallet","key":"Wallet-cLy8cxa5NV38iYhL54aL0"}]}},{"key":"Login-xSLkhvAiyTCkLxuy4uYNf","name":"Login"}]}',
  d24: '{"stale":false,"type":"stack","key":"stack-BHRAm0KmZiHcbNZGAim2L","index":2,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24"],"routes":[{"key":"Home-mK6Y9vqW7MBohXpzT-Nrq","name":"Home","state":{"stale":false,"type":"tab","key":"tab-Z_ThadS8FJg1PlikwmxV1","index":3,"routeNames":["Markets","Portfolio","Contest","Wallet","Live"],"history":[{"type":"route","key":"Markets-DpZIDS3-lr55avUgNTd1H"},{"type":"route","key":"Wallet-bdIojX-if0vnrRCewda8Y"}],"routes":[{"name":"Markets","key":"Markets-DpZIDS3-lr55avUgNTd1H"},{"name":"Portfolio","key":"Portfolio-GQcGoMRtZZRSKK6eHD8Tp"},{"name":"Contest","key":"Contest-qy3MyArQAFBRrErTBnyGw"},{"name":"Wallet","key":"Wallet-bdIojX-if0vnrRCewda8Y"},{"name":"Live","key":"Live-aw6P7ywNofs7UXFYOg1p5"}]}},{"key":"WalletStack-erI6SGYCXZpwf4tZj7GtD","name":"WalletStack","params":{"screen":"WalletAdd"},"state":{"stale":false,"type":"stack","key":"stack-SIeXAfj776RabR541IE31","index":0,"routeNames":["WalletAdd","WalletWithdraw","Transaction","TransactionScreen","Kyc","WalletStatus","WalletAmountReview"],"routes":[{"key":"WalletAdd-PAKCwdk_BltQBW_UfMMM6","name":"WalletAdd"}]}},{"key":"Direct24-gB7g4ZOhMi5FsoT2pg1Jj","name":"Direct24","params":{"rechargeDetails":{"amount":"50","currency":"CAD","lang":"EN","country":"CA","payerEmail":"aromaauraproducts@gmail.com","payerFirstName":"Ricardo","couponCode":""}}}]}',
  hashtag:
    '{"stale":false,"type":"stack","key":"stack-TdyS4og1pgJRr5yvD6WMF","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-mqpyMudN0uZrsefPl_Op9","name":"Home","state":{"stale":false,"type":"tab","key":"tab-tHELWQF8cZ51cp8cyS9p4","index":0,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-mpkjledyI8q_urz3RUAnS"}],"routes":[{"name":"Markets","key":"Markets-mpkjledyI8q_urz3RUAnS"},{"name":"Contest","key":"Contest-ykWqxMAOveEgVW4fvsPnM"},{"name":"Portfolio","key":"Portfolio-4JkWnjVkMBhObyMkOp8O-"},{"name":"Wallet","key":"Wallet-0AzHhWTA_-qaE7j1SKAYT"}]}},{"key":"HashTag-_AUgyxyifGFvKj9t5Ela1","name":"HashTag","params":{"hash_tag":"#GJRvsDCP","selectedSubCategory":""}}]}',
  walletAdd: '{"stale":false,"type":"stack","key":"stack-jOoN_O0ltDB4x5n6pcbOr","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-UPZeOOTvlwmtQ3pBBPcBG","name":"Home","state":{"stale":false,"type":"tab","key":"tab-9Uxp7gySra5sp-KnU52VZ","index":3,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-_Lvue4plFCspoqZ7Jsi60"},{"type":"route","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}],"routes":[{"name":"Markets","key":"Markets-_Lvue4plFCspoqZ7Jsi60","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}},{"name":"Contest","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"},{"name":"Portfolio","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"},{"name":"Wallet","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}]},"params":{"screen":"Markets","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}}},{"key":"WalletStack-q_kO2YyilefOrBCGgAxDr","name":"WalletStack","params":{"screen":"WalletAdd"},"state":{"stale":false,"type":"stack","key":"stack-Oxhtvv4f-XL3JuA7NZfJw","index":0,"routeNames":["WalletAdd","WalletWithdraw","Transaction","TransactionScreen","Kyc","WalletStatus","WalletAmountReview"],"routes":[{"key":"WalletAdd--UcjSPuX2OrVeaJ6btHOK","name":"WalletAdd"}]}}]}',
  walletWithdraw: '{"stale":false,"type":"stack","key":"stack-ZoqQj9KxvCXfaJNR8Y0O8","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-UPZeOOTvlwmtQ3pBBPcBG","name":"Home","state":{"stale":false,"type":"tab","key":"tab-NaozBao-FevCe5sS8_DPu","index":3,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-_Lvue4plFCspoqZ7Jsi60"},{"type":"route","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}],"routes":[{"name":"Markets","key":"Markets-_Lvue4plFCspoqZ7Jsi60","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}},{"name":"Contest","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"},{"name":"Portfolio","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"},{"name":"Wallet","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}]},"params":{"screen":"Markets","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}}},{"key":"WalletStack-LhzbvTHp5UkcZrfkYAe1n","name":"WalletStack","params":{"screen":"WalletWithdraw"},"state":{"stale":false,"type":"stack","key":"stack-VH4auI-cOwQ1WiJRMaRW3","index":0,"routeNames":["WalletAdd","WalletWithdraw","Transaction","TransactionScreen","Kyc","WalletStatus","WalletAmountReview"],"routes":[{"key":"WalletWithdraw-UCYxGI_hcMJtvABcch-03","name":"WalletWithdraw"}]}}]}',
  rewards: '{"stale":false,"type":"stack","key":"stack-WqrLZ7H4hbl84ng5fUETG","index":0,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-UPZeOOTvlwmtQ3pBBPcBG","name":"Home","state":{"stale":false,"type":"tab","key":"tab-7Ta2CfmKpxswepRGfVwsq","index":1,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-_Lvue4plFCspoqZ7Jsi60"},{"type":"route","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"}],"routes":[{"name":"Markets","key":"Markets-_Lvue4plFCspoqZ7Jsi60","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}},{"name":"Contest","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"},{"name":"Portfolio","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"},{"name":"Wallet","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}]},"params":{"screen":"Markets","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}}}]}',
  portfolio: '{"stale":false,"type":"stack","key":"stack-wayHcEJbjzZze1RsapKe5","index":0,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-UPZeOOTvlwmtQ3pBBPcBG","name":"Home","state":{"stale":false,"type":"tab","key":"tab-fsvfUyOW-Qk34jpBshxKB","index":2,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-_Lvue4plFCspoqZ7Jsi60"},{"type":"route","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"}],"routes":[{"name":"Markets","key":"Markets-_Lvue4plFCspoqZ7Jsi60","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}},{"name":"Contest","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"},{"name":"Portfolio","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"},{"name":"Wallet","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}]},"params":{"screen":"Markets","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}}}]}',
  wallet: '{"stale":false,"type":"stack","key":"stack-JDk9AJTD8ug4edWzUuxfo","index":0,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","RewardsStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24","PartnerError","LinkqCards"],"routes":[{"key":"Home-UPZeOOTvlwmtQ3pBBPcBG","name":"Home","state":{"stale":false,"type":"tab","key":"tab-Jc92T9Rt4U81RoPDtJDNa","index":3,"routeNames":["Markets","Contest","Portfolio","Wallet"],"history":[{"type":"route","key":"Markets-_Lvue4plFCspoqZ7Jsi60"},{"type":"route","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}],"routes":[{"name":"Markets","key":"Markets-_Lvue4plFCspoqZ7Jsi60","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}},{"name":"Contest","key":"Contest-fyAlQOWbHKOf_DHgOp-JJ"},{"name":"Portfolio","key":"Portfolio-SlxxuQCZE-V2dAG5GN8iC"},{"name":"Wallet","key":"Wallet-5fxTOMKofMF6Tkmj5MUbF"}]},"params":{"screen":"Markets","params":{"isFirstLogin":false,"isLoadProbe":{"isrefersh":true}}}}]}'
};

export const d24Redirect = status => {
  if (!isMobile()) {
    return (
      '{"stale":false,"type":"stack","key":"stack-e4TMROfW-UOCaoEFOfojJ","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","Portfolio","Wallet","WalletStack","PortfolioStack","ClubStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection"],"routes":[{"name":"Home","key":"Home-w40-JlDtajLpgMm6CI-8_"},{"key":"Wallet-SRQIf_c9h_3nqquODh9hz","name":"Wallet","params":{"d24Status":"' +
      status +
      '"}}]}'
    );
  } else {
    return (
      '{"stale":false,"type":"stack","key":"stack-B7DO6RePavjDrSND7JJxK","index":1,"routeNames":["Home","HashTag","Login","Profile","Event","ProTrader","WalletStack","PortfolioStack","ClubStack","Refer","Fantasy","Account","WalletSuccess","LoginOptions","LanguageSelection","Direct24"],"routes":[{"key":"Home-2BYgTnAAhy6WGWzkV9aj2","name":"Home","state":{"stale":false,"type":"tab","key":"tab-36lBXP_bJCUOHh3n3W22j","index":3,"routeNames":["Markets","Portfolio","Contest","Wallet","Live"],"history":[{"type":"route","key":"Markets--CU-BHh03dlQUBOCb_-jH"},{"type":"route","key":"Wallet-7hQw3aYUu2A6Z_egXFisA"}],"routes":[{"name":"Markets","key":"Markets--CU-BHh03dlQUBOCb_-jH"},{"name":"Portfolio","key":"Portfolio-hWGkLvobqPkjS4Rw-rsnl"},{"name":"Contest","key":"Contest-uhRMU2SrylYP6FrX7CUKk"},{"name":"Wallet","key":"Wallet-7hQw3aYUu2A6Z_egXFisA"},{"name":"Live","key":"Live-1CBqo5jPRpGfU6ngQUANs"}]}},{"key":"WalletStack-2pEN80dsIW1hPbcAsNJZm","name":"WalletStack","params":{"screen":"WalletAdd"},"state":{"stale":false,"type":"stack","key":"stack-aCGw-wmG24EeH2_KAQJgI","index":0,"routeNames":["WalletAdd","WalletWithdraw","Transaction","TransactionScreen","Kyc","WalletStatus","WalletAmountReview"],"routes":[{"key":"WalletAdd-uRRh0vR_bvnbjK_OPvZQS","name":"WalletAdd","params":{"d24Status":"' +
      status +
      '"}}]}}]}'
    );
  }
};

export const loadScript = userData => {
  if (!window.$zoho) {
    const script = document.createElement("script");
    script.id = "zsiqchat";
    script.type = "text/javascript";
    script.src = "";

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || {
      widgetcode:
        "siq12141b84d459d0a3d9e1343cecc6978aae3916a6387217b5a4e3726022b43fd8",
      values: {},
      ready: function () {
        window.$zoho.salesiq.visitor.info({
          Mobile: userData?.mobile,
          email: userData?.email,
        });
      },
    };
    var d = document;
    var s = d.createElement("script");
    s.type = "text/javascript";
    s.id = "zsiqscript";
    s.defer = true;
    s.src = "https://salesiq.zohopublic.in/widget";
    var t = d.getElementsByTagName("script")[0];
    t.parentNode.insertBefore(s, t);

    document.body.appendChild(script);
  } else {
    const scriptElem = document.querySelectorAll("[data-id='zsalesiq']")[0];
    if (scriptElem) {
      window.$zoho.salesiq.floatbutton.visible("show");
      //scriptElem.setAttribute('style', 'display:block !important');

      // scriptElem.style.display = 'block';
    }
  }
};

export const removeScript = () => {
  const scriptElem = document.querySelectorAll("[data-id='zsalesiq']")[0];
  if (scriptElem) {
    window.$zoho.salesiq.floatbutton.visible("hide");
  }
};

export const defaultRange = {start: 0, end: 100};

export const setRange = updatedRange => {
  defaultRange.start = updatedRange?.start;
  defaultRange.end = updatedRange?.end;
};

export const giveCorrectPrice = ({yPrice, nPrice, isFixed = 2}) => {
  const price =
    yPrice !== undefined ? yPrice : nPrice !== undefined ? nPrice : null;
  if (price) {
    if (defaultRange.end > 10) {
      return price?.toFixed(isFixed);
    } else if (defaultRange.end > 1) {
      return (price / 10)?.toFixed(isFixed);
    } else {
      return (price / 100)?.toFixed(isFixed);
    }
  } else {
    return price;
  }
};

export const getReturns = price => {
  if (defaultRange.end > 10) {
    return price;
  } else if (defaultRange.end > 1) {
    return Number((price * 10).toFixed(0));
  } else {
    return Number((price * 100).toFixed(0));
  }
};

export const getReturnsPerShare = price => {
  if (defaultRange.end > 10) {
    return price * 100;
  } else if (defaultRange.end > 1) {
    return price * 10;
  } else {
    return price * 1;
  }
};

export const getCounterRange = () => {
  if (defaultRange.end > 10) {
    return {
      min: defaultRange.start + 1,
      max: defaultRange.end - 1,
      addSubVar: 1,
    };
  } else if (defaultRange.end > 1) {
    return {
      min: defaultRange.start + 0.1,
      max: defaultRange.end - 0.1,
      addSubVar: 0.1,
    };
  } else {
    return {
      min: defaultRange.start + 0.01,
      max: defaultRange.end - 0.01,
      addSubVar: 0.01,
    };
  }
};

export const getPrice = price => {
  if (defaultRange.end > 10) {
    return price;
  } else if (defaultRange.end > 1) {
    return price.toFixed(2);
  } else {
    return price.toFixed(2);
  }
};

export const getFieldValidation = () => {
  if (defaultRange.end > 10) {
    return {
      min: {
        value: 1,
        message: "Price should be between 1 and 99",
      },
      max: {
        value: 99,
        message: "Price should be between 1 and 99",
      },
    };
  } else if (defaultRange.end > 1) {
    return {
      min: {
        value: 1,
        message: "Price should be between 1 and 9.9",
      },
      max: {
        value: 9.9,
        message: "Price should be between 1 and 9.9",
      },
    };
  } else {
    return {
      min: {
        value: 0.01,
        message: "Price should be between 0.01 and 0.99",
      },
      max: {
        value: 0.99,
        message: "Price should be between 0.01 and 0.99",
      },
    };
  }
};

export const getModifiedRange = range => {
  if (defaultRange.end > 10) {
    return range;
  } else if (defaultRange.end > 1) {
    return range / 10;
  } else {
    return range / 100;
  }
};

export const getRangeMod = range => {
  if (defaultRange.end > 10) {
    return {min: 1, mid: 50, max: 100};
  } else if (defaultRange.end > 1) {
    return {min: 0.1, mid: 5, max: 10};
  } else {
    return {min: 0.01, mid: 0.5, max: 1};
  }
};

export const getSharesOnAddSub = val => {
  if (defaultRange.end > 10) {
    return val;
  } else if (defaultRange.end > 1) {
    return val;
  } else {
    return val * 10;
  }
};

export const getDefaultSharesByPriceRange = () => {
  if (defaultRange.end > 10) {
    return 0.1;
  } else if (defaultRange.end > 1) {
    return 1;
  } else {
    return 10;
  }
};

export const getMinSellSharesByPriceRange = () => {
  if (defaultRange.end > 10) {
    return 0.1;
  } else if (defaultRange.end > 1) {
    return 1;
  } else {
    return 10;
  }
};

export const getMaxBuySharesByPriceRange = custom => {
  const val = custom ?? 1000;
  const factor = defaultRange?.end ?? 100;
  return (val * 100) / factor;
};

export const getMinBuySharesByPriceRange = () => {
  if (defaultRange.end > 10) {
    return 0.1;
  } else if (defaultRange.end > 1) {
    return 1;
  } else {
    return 10;
  }
};

export const showLoginModal = (dispatch, params = {}) => {
  dispatch(setShowLoginModal(true, params));
};
